import React from 'react';
import PropTypes from 'prop-types';

export default class CountDown extends React.Component {

    constructor (props){
        super(props);
        this.state = this.getTimeRemaining(this.props.expires);
    }

    componentDidMount() {
        this.interval = setInterval(() => {
            const remainingTime = this.getTimeRemaining(this.props.expires);
            if (remainingTime.total <= 0) {
                clearInterval(this.interval);
            } else {
                this.setState(remainingTime);
            }
        }, 1000);
    }

    getTimeRemaining(expires){
        var t = Date.parse(expires) - Date.parse(new Date());
        var seconds = Math.floor( (t/1000) % 60 );
        var minutes = Math.floor( (t/1000/60) % 60 );
        var hours = Math.floor( (t/(1000*60*60)) % 24 );
        var days = Math.floor( t/(1000*60*60*24) );
        return {
            'total': t,
            'days': days.toString().padStart(2, '0'),
            'hours': hours.toString().padStart(2, '0'),
            'minutes': minutes.toString().padStart(2, '0'),
            'seconds': seconds.toString().padStart(2, '0')
        };
    }

    componentWillUnmount( ) {
        clearInterval(this.interval);
    }

    render () {
        return(
            <div className="timer--display">
                <p className="timer--display-text" >Offer ends...</p>
                <span className="timer--display-item" data-timer-label="days">{this.state.days}</span>:
                <span className="timer--display-item" data-timer-label="hours">{this.state.hours}</span>:
                <span className="timer--display-item" data-timer-label="mins">{this.state.minutes}</span>
            </div>
        )
    }
}